module.exports = __webpack_public_path__ + "img/image02.9752d760.jpg";